import { z } from 'zod';

const notificationActorSchema = z.object({
    id: z.number(),
    displayName: z.string(),
}).nullable();

export const notificationSchema = z.object({
    id: z.number(),
    actor: notificationActorSchema,
    type: z.string(),
    title: z.string(),
    message: z.string().optional().default(''),
    target_url: z.string().optional().default(''),
    metadata: z.record(z.any()).optional().default({}),
    is_read: z.boolean(),
    created_at: z.string(),
});

export const notificationListResponseSchema = z.object({
    items: z.array(notificationSchema).default([]),
    unread_count: z.number().int().nonnegative().default(0),
});

export type INotification = z.infer<typeof notificationSchema>;
export type INotificationListResponse = z.infer<typeof notificationListResponseSchema>;
